// @ts-check
import { acceptHMRUpdate, defineStore } from 'pinia';

/** @import { Entorno, FormularioPersonalizable, Modulo } from '@erpagroapp/types' */

export const useAppConfigStore = defineStore('appConfig', {
  state: () => ({
    /**
     * Controls whether the user needs to log in. If `true`, the login page will be rendered.
     * @type {boolean}
     */
    loginNeeded: true,

    /**
     * Controls whether the user needs to activate the app. If `true`, the activation page will be rendered.
     * @type {boolean}
     */
    appActivationNeeded: true,

    // firebaseData: null, // TODO: Considerar borrar lo relacionado con PushNotifications, en teoría ya no se están usando

    /**
     * The date of the first login into the app.
     * @type {Date | null}
     */
    firstStartDateApp: null,

    /**
     * The access token of the user after authentication.
     * @type {string | null}
     */
    accessTokenERP: null,

    /**
     * The user login data.
     * @type {UserLoginData | null}
     */
    userLoginData: null,

    /**
     * The user enviroment.
     * @type {Entorno | null}
     */
    userEnviroment: null,

    /**
     * A list of modules that the user has access to.
     * @type {Modulo[] | null}
     */
    userAccesivility: [],

    /**
     * A list of form personalizations.
     * @type {FormularioPersonalizable[] | null}
     */
    personalizacionesFormularios: null,
  }),

  getters: {
    /* TODO: Considerar borrar lo relacionado con PushNotifications, en teoría ya no se están usando
    getIdDispositivePush: (state) => (
      state.firebaseData != null ? state.firebaseData.registrationId : null),
      */
    getAccessTokenERP: (state) => state.accessTokenERP || '',
    getPersonalizacionesFormularios: (state) => state.personalizacionesFormularios || [],

    /**
     * Retrieves available process IDs based on user accessibility data.
     * @returns {number[]} An array of available process IDs.
     */
    availableProcessIds: (state) => {
      if (!Array.isArray(state.userAccesivility)) {
        return [];
      }

      const allProcesses = state.userAccesivility
        .flatMap((element) => [...element.Procesos, ...element.SubModulos.flatMap((subModule) => subModule.Procesos)])
        .map((elementDos) => elementDos.Id);

      return allProcesses;
    },

    /**
     * Retrieves available module IDs based on user accessibility data.
     * @returns {number[]} An array of available module IDs.
     */
    availableModuleIds: (state) => {
      if (!state.userAccesivility) {
        return [];
      }

      return state.userAccesivility
        .filter((element) => element.Procesos.length > 0 || element.SubModulos.length > 0)
        .map((element) => element.Id);
    },
  },

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useAppConfigStore, import.meta.webpackHot));
}

/**
 * @typedef {object} UserLoginData
 * @property {string} UserName - The user name.
 * @property {Date} loginDate - The login date.
 */
